export default http => ({
    async my_active() {
        let {data} = await http.get(`user-events?status[]=open&status[]=payed`);
        return data;
    },
    async event(event_id) {
        let {data} = await http.get(`events/${event_id}/requests`);
        return data;
    },

    async get(user_event_id) {
        let {data} = await http.get(`user-events/${user_event_id}`);
        return data;
    },

    async store(event_id) {
        let {data} = await http.post(`events/${event_id}/requests`);
        return data;
    },
    async destroy(user_event_id) {
        let {data} = await http.delete(`user-events/${user_event_id}`);
        return data;
    },
    async store_member(user_event_id, fields) {
        let {data} = await http.post(`user-events/${user_event_id}/members`, fields);
        return data;
    },
    async update_member(user_event_id, event_user_member_id, fields) {
        let {data} = await http.patch(`user-events/${user_event_id}/members/${event_user_member_id}`, fields);
        return data;
    },

    async check_coupon(user_event_id, code) {
        let {data} = await http.post(`user-events/${user_event_id}/coupon`, {code: code});
        return data;
    },

    async destroy_coupon(user_event_id) {
        let {data} = await http.delete(`user-events/${user_event_id}/coupon`);
        return data;
    },
});